/* eslint-disable import/prefer-default-export */

import styled, { css } from 'styled-components';
import {
    ColorNeutralWhite,
    ColorNordicGrey3,
    Spacing4,
    Spacing8,
    Spacing12,
    Spacing16,
    Spacing24
} from 'autogen/design-tokens/tokens';
import type { IMenuSection } from 'components/generic/menu/shared/types';
import type { Size } from 'components/List/shared/types';
import getTypeStyling from 'helpers/getTypeStyling';

export const SectionSizes = {
    sm: {
        section: css`
            padding: ${Spacing4} ${Spacing12};
        `,
        heading: css`
            padding: ${Spacing8} ${Spacing12} ${Spacing8} ${Spacing12};
        `
    },
    md: {
        section: css`
            padding: ${Spacing8} ${Spacing16};
        `,
        heading: css`
            padding: ${Spacing16} ${Spacing24} ${Spacing8} ${Spacing16};
        `
    },
    lg: {
        section: css`
            padding: ${Spacing8} ${Spacing16};
        `,
        heading: css`
            padding: ${Spacing16} ${Spacing24} ${Spacing8} ${Spacing16};
        `
    },
    xl: {
        section: css`
            padding: ${Spacing8} ${Spacing16};
        `,
        heading: css`
            padding: ${Spacing16} ${Spacing24} ${Spacing8} ${Spacing16};
        `
    },
    xxl: {
        section: css`
            padding: ${Spacing8} ${Spacing16};
        `,
        heading: css`
            padding: ${Spacing16} ${Spacing24} ${Spacing8} ${Spacing16};
        `
    }
};

export const MenuSection = styled.div<{ size?: IMenuSection['size'] }>`
background-color: ${ColorNeutralWhite};
${({ size, theme }) =>
    size
        ? getTypeStyling((resolvedSize: Size) => SectionSizes[resolvedSize].section)(size as Size)
        : getTypeStyling((resolvedSize: Size) => SectionSizes[resolvedSize].section)((theme as any).size)}
`;

export const MenuSectionHeader = styled.div<{ size?: IMenuSection['size'] }>`
display: flex;
align-items: center;

${({ size, theme }) =>
    size
        ? getTypeStyling((resolvedSize: Size) => SectionSizes[resolvedSize].heading)(size as Size)
        : getTypeStyling((resolvedSize: Size) => SectionSizes[resolvedSize].heading)((theme as any).size)}
`;
